// Reusable validation patterns that mirror server-side validators
// Keep these in sync with app/validators/
import { isValidPhoneNumber } from "libphonenumber-js"

const VALIDATORS = {
  email: {
    // Mirrors email_validator.rb regex: /\A([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})\z/i
    pattern: /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i,
    test: (value) => VALIDATORS.email.pattern.test(value),
  },
  phone: {
    // We support all international phone numbers.
    // We use Google's "libphonenumber-js" to validate this.
    pattern: /^(\+46|0)[\s-]?[1-9][\d\s-]{7,14}$/,
    test: (value) => {
      // Swedish numbers are often entered with the "0" trunk prefix
      // (e.g. "070-123 45 67"). Swap it for the +46 country code so
      // libphonenumber-js can validate it as an international number.
      const trimmed = value.trim()
      const normalized = trimmed.startsWith(`0`)
        ? trimmed.replace(/^0/, `+46`)
        : trimmed

      return isValidPhoneNumber(normalized)
    },
  },
}

export default VALIDATORS
